// Copyright ©️ 2026 eVolve MEP, LLC

import { type StrongOmit, type RenderableUser, useEvolvePaginatedGet } from '@evolvemep/api-ts';

import { validateUserNameOrEmail } from 'helpers/userHelpers';

import {
  SearchableMultiSelect,
  type SearchableMultiSelectProps,
} from './TypeSafeSelect/PaginatedSelectors/SearchableMultiSelect';

type Props = StrongOmit<
  SearchableMultiSelectProps<'admin/user', RenderableUser, 'userId'>,
  'getItemLabel' | 'paginatedGet' | 'idKey'
>;

export const AssigneeSelect = ({
  nowrap = false,
  flex = 1,
  placeholder = 'Select assignees',
  ...otherProps
}: Props) => {
  const getUsers = useEvolvePaginatedGet(`admin/user`);
  return (
    <SearchableMultiSelect
      {...otherProps}
      nowrap={nowrap}
      flex={flex}
      placeholder={placeholder}
      paginatedGet={getUsers}
      idKey="userId"
      getItemLabel={validateUserNameOrEmail}
    />
  );
};
